// toolbar.js

import { DraggableNode } from './draggableNode';

export const PipelineToolbar = () => {
    return (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50">
            <div className='overflow-hidden rounded-pill'>
            <div className="
                px-6 py-3 rounded-pill 
                border border-white/10 
                bg-white/5 backdrop-blur-md 
                shadow-[0_8px_32px_rgba(0,0,0,0.3)]
                flex items-center gap-4
                max-w-[90vw] overflow-x-auto scrollbar-hide
            ">
                <div className="flex items-center gap-2 pr-4 border-r border-white/10">
                    <div className="w-2 h-2 rounded-full bg-pipeline-accent animate-pulse" />
                    <span className="text-xs font-bold uppercase tracking-widest text-pipeline-muted">Nodes</span>
                </div>
                <div className="flex gap-2">
                    <DraggableNode type='customInput' label='Input' />
                    <DraggableNode type='llm' label='LLM' />
                    <DraggableNode type='customOutput' label='Output' />
                    <DraggableNode type='text' label='Text' />
                    <DraggableNode type='condition' label='Condition' />
                    <DraggableNode type='math' label='Math' />
                    <DraggableNode type='database' label='Database' />
                    <DraggableNode type='api' label='API' />
                    <DraggableNode type='transform' label='Transform' />
                </div>
            </div>
            </div>
        </div>
    );
};
